import React, { Component } from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import { Form, Col} from 'react-bootstrap';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class ExamForm extends Component {
    constructor(props) {
      super(props);
      this.initialState = {
        idProfilCbt: '',
        namaProfil: '',
        kodeTipeCbt: '',
        kodeSubTipeCbt: '',
        idKelas: ''        
      }      
      
      if(props.profil){
        this.state = props.profil
      } else {
        this.state = this.initialState;
      }
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }  
  
    handleChange(event) {
      const name = event.target.name;
      const value = event.target.value;
  
      this.setState({
        [name]: value
      })
    }    
  
    handleSubmit(event) {
      event.preventDefault();
      // extract form data
      const formdata = new FormData(event.target)
    
      // convert FormData to json object
      // SOURCE: https://stackoverflow.com/a/46774073
      const json = {}
      formdata.forEach(function(value, prop){
        json[prop] = value
      }) 
      
      this.props.onFormSubmit(json);
      this.setState(this.initialState);
    }

    renderDropdown(){
        let kelas = this.props.kelas;
        if(!__.isEmpty(kelas)){
            return kelas.map((kel) => {
                return (
                    <option key={kel.idKelas} value={kel.idKelas}>{kel.namaKelas}</option>
                )
            })
        }
    }

    handleBack() {
        console.log('sdfsdf')
        this.props.handleBack();
    }
  
    render() {   
      //console.log(this)
      const profil = this.state; 
      let pageTitle;
      if(this.state.idProfilCbt) {
        pageTitle = <h2>Edit Exam</h2>
      } else {
        pageTitle = <h2>Add Exam</h2>
      }
  
      return(
        <div>  
          <h4>{pageTitle}</h4>
          <Col sm={6}>
            <Form onSubmit={this.handleSubmit}>                    
              <Form.Group controlId="nama">
                <Form.Label>Judul Exam : </Form.Label>
                <Form.Control
                  type="text"
                  name="namaProfil" 
                  defaultValue={profil.namaProfil} onChange={this.handleChange}                                 
                  placeholder="Input Judul..." required/>
              </Form.Group>
              <Form.Group controlId="kelas">
                <Form.Label>Kelas :</Form.Label>
                <select className="form-control" name="idKelas" defaultValue={profil.idKelas} required>
                    <option value="">Pilih Kelas...</option>
                    {this.renderDropdown()}
                </select>
              </Form.Group>
              <Form.Group controlId="tipe">
                <Form.Label>Tipe Exam :</Form.Label>
                <select className="form-control" name="kodeSubTipeCbt" defaultValue={profil.kodeSubTipeCbt} required>
                  <option value="">Pilih Tipe...</option>
                    <option value="UAS">PAT</option>
                    <option value="UTS">PTS</option>                    
                </select>
              </Form.Group>
              <Form.Group>
                <Form.Control type="hidden" name="idProfilCbt" value={profil.idProfilCbt} />
                <Form.Control type="hidden" name="kodeTipeCbt" value="EXAM" />
                <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}><ArrowBackIosIcon fontSize="small"/>Batal</button>
                        
                <button type="submit" className="btn btn-primary pull-right">Simpan</button>
              </Form.Group>
            </Form>
          </Col> 
        </div>
      )
    }
  }


  const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}
export default connect(mapStateToProps)(ExamForm);